export * from './FaceExpressionNet';
export * from './FaceExpressions';
//# sourceMappingURL=index.js.map